import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Button, ButtonType } from '../atoms/button';
import { HomeDailyLessonChangeIcon } from '../atoms/icons/home_daily_lesson_change_icon';
import { HomeDailyLessonPopoverArrowIcon } from '../atoms/icons/home_daily_lesson_popover_arrow_icon';
import { Colors } from '../styles/variables';
import Duration from '../atoms/duration';
export const HomeDailyLessonPopover = ({ title, thumbnailUrl, duration, showChangeButton, top, left, arrowLeft, isClosing, positionAbsolute, onExited, onClickStart, onClickChange, classObject, }) => {
    const onClickPopoverPanel = (event) => {
        event.stopPropagation();
    };
    const onAnimationEnd = (event) => {
        if (isClosing && event.target === event.currentTarget) {
            onExited === null || onExited === void 0 ? void 0 : onExited();
        }
    };
    return (React.createElement("div", { className: css(styles.container, positionAbsolute && styles.containerAbsolute, isClosing && styles.containerClosing, classObject), style: { top, left, transformOrigin: `${arrowLeft + 34}px 0` }, onAnimationEnd: onAnimationEnd },
        React.createElement("div", { className: css(styles.arrow), style: { left: arrowLeft } },
            React.createElement(HomeDailyLessonPopoverArrowIcon, null)),
        React.createElement("div", { className: css(styles.panel), onClick: onClickPopoverPanel },
            React.createElement("div", { className: css(styles.contents) },
                React.createElement("div", { className: css(styles.thumbnail) },
                    React.createElement("img", { className: css(styles.thumbnailImage), src: thumbnailUrl }),
                    React.createElement(Duration, { className: css(styles.duration), duration: duration, radius: true })),
                React.createElement("div", { className: css(styles.caption) },
                    React.createElement("p", { className: css(styles.title) }, title))),
            React.createElement("div", { className: css(styles.actions) },
                React.createElement(Button, { buttonType: ButtonType.primary, isRadius: true, className: css(styles.actionButton), onClick: onClickStart }, "\u30B9\u30BF\u30FC\u30C8\uFF01"),
                showChangeButton && (React.createElement(Button, { buttonType: ButtonType.alertOutline, isRadius: true, className: css(styles.actionButton), onClick: onClickChange },
                    React.createElement("span", { className: css(styles.changeButtonContent) },
                        React.createElement(HomeDailyLessonChangeIcon, null),
                        React.createElement("span", null, "\u30C1\u30A7\u30F3\u30B8"))))))));
};
const styles = StyleSheet.create({
    container: {
        position: 'fixed',
        width: 340,
        minWidth: 340,
        pointerEvents: 'none',
        filter: 'drop-shadow(rgba(118, 137, 162, 0.15) 0px 0px 20px)',
        animationName: {
            '0%': { opacity: 0, transform: 'scale(0.5)' },
            '55%': { opacity: 1, transform: 'scale(1.04)' },
            '100%': { opacity: 1, transform: 'scale(1)' },
        },
        animationDuration: '0.4s',
        animationTimingFunction: 'ease-out',
        animationFillMode: 'both',
    },
    // XL未満: ドキュメント基準(absolute)でアンカーし、ページと一緒にネイティブスクロールさせる（追従遅延の防止）
    containerAbsolute: {
        position: 'absolute',
    },
    containerClosing: {
        animationName: {
            '0%': { opacity: 1, transform: 'scale(1)' },
            '100%': { opacity: 0, transform: 'scale(0.5)' },
        },
        animationDuration: '0.2s',
        animationTimingFunction: 'ease-in',
    },
    arrow: {
        position: 'absolute',
        top: 2,
        width: 68,
        height: 36,
        lineHeight: 0,
        pointerEvents: 'none',
    },
    panel: {
        position: 'relative',
        marginTop: 18,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: 10,
        padding: 16,
        borderRadius: 20,
        backgroundColor: Colors.White,
        pointerEvents: 'auto',
    },
    contents: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        alignSelf: 'stretch',
        gap: 8,
        minWidth: 0,
    },
    thumbnail: {
        position: 'relative',
        width: 162,
        height: 95,
        flexShrink: 0,
        borderRadius: 14,
        overflow: 'hidden',
    },
    thumbnailImage: {
        width: '100%',
        height: '100%',
        display: 'block',
        objectFit: 'cover',
        borderRadius: 4,
    },
    duration: {
        position: 'absolute',
        right: 6,
        bottom: 7,
    },
    caption: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minWidth: 0,
        gap: 2,
    },
    title: {
        margin: 0,
        fontSize: 14,
        fontWeight: 'bold',
        lineHeight: 1.4,
        letterSpacing: 0.56,
        color: Colors.Black,
        whiteSpace: 'normal',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        alignSelf: 'stretch',
        gap: 8,
        width: '100%',
    },
    actionButton: {
        flex: 1,
        width: 'auto',
        height: 48,
        minHeight: 48,
        maxHeight: 48,
        padding: '0 16px',
        fontSize: 16,
        fontWeight: 'bold',
        lineHeight: 1.6,
        letterSpacing: 1.28,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    changeButtonContent: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
    },
});
